import { render, staticRenderFns } from "./LeadCreateCard.vue?vue&type=template&id=6f0fd070"
import script from "./LeadCreateCard.vue?vue&type=script&lang=js"
export * from "./LeadCreateCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports